// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"3c2b2d38","798":"ee6c5929","956":"448127d1"}[chunkId] + ".chunk.js";
};